export default function IconContainer({ color, children }) {
  const style = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
    backgroundColor: color,
  };

  return <div style={style}>{children}</div>;
}
